import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const billingDetailRoutes = {
  name: 'billing-detail',
  path: 'billing-detail',
  component: () => import('./BillingDetail.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
